import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { GenericError, NextStep } from '../../model/legal.model'

export interface NextStepsState {
  loading: boolean | null
  errorMessage: string
  errorCode: string
  data: NextStep[]
}

export const initialState: NextStepsState = {
  data: [],
  loading: null,
  errorMessage: '',
  errorCode: '',
}

interface FetchNextSteps {
  isOffline: boolean
  isPostpaid: boolean
}

export const nextStepsSlice = createSlice({
  name: 'nextSteps',
  initialState,
  reducers: {
    fetchNextSteps: (_state, _action: PayloadAction<FetchNextSteps>) => {
      return {
        ...initialState,
        loading: true,
      }
    },
    fetchNextStepsSuccess: (_state, action: PayloadAction<NextStep[]>) => {
      return {
        ...initialState,
        loading: false,
        data: action.payload,
      }
    },
    fetchNextStepsError: (_state, action: PayloadAction<GenericError>) => {
      const { payload } = action
      return {
        ...initialState,
        loading: false,
        errorCode: payload.code || '500',
        errorMessage: payload.message || 'Error',
      }
    },
    resetNextSteps: () => initialState,
  },
})

export const {
  fetchNextSteps,
  fetchNextStepsSuccess,
  fetchNextStepsError,
  resetNextSteps,
} = nextStepsSlice.actions

const nextStepsReducer = nextStepsSlice.reducer

export default nextStepsReducer
